import React from 'react';
import './styles.scss';

export const SubmitButton = props => {
  return (
    <input
      data-testid="click-submit-button"
      data-clickable="true"
      type="submit"
      className="submit__button"
      value={props.text}
      {...props}
    />
  );
};
